/* tslint:disable */
/* eslint-disable */
/**
 * story
 * storyのAPI
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PickUpVariables
 */
export interface PickUpVariables {
    /**
     * PickUp欄のタイトル
     * @type {string}
     * @memberof PickUpVariables
     */
    pickup: string;
    /**
     * Topページに表示されるキーワード一覧
     * @type {Array<string>}
     * @memberof PickUpVariables
     */
    keywords: Array<string>;
}

export function PickUpVariablesFromJSON(json: any): PickUpVariables {
    return PickUpVariablesFromJSONTyped(json, false);
}

export function PickUpVariablesFromJSONTyped(json: any, ignoreDiscriminator: boolean): PickUpVariables {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pickup': json['pickup'],
        'keywords': json['keywords'],
    };
}

export function PickUpVariablesToJSON(value?: PickUpVariables | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pickup': value.pickup,
        'keywords': value.keywords,
    };
}

